"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaHorario = exports.yupHorario = void 0;
const yup = __importStar(require("yup"));
const curso_1 = require("../enums/curso");
// import { IHorarioAula } from './horarioAula';
exports.yupHorario = yup.object({
    horaIni: yup.string().default('').max(5).required().label('Horário  Inicial'),
    horaFim: yup.string().default('').max(5).required().label('Horário  Final'),
    grau: yup
        .mixed()
        .oneOf(Object.values(curso_1.ECursoGrau))
        .required()
        .default(curso_1.ECursoGrau.Fundamental)
        .label('Nível'),
    serieIni: yup.string().default('').max(1).required().label('Série Inicial'),
    serieFim: yup.string().default('').max(1).required().label('Série Inicial'),
    aulas: yup.number().required().integer().default(0).label('Aula'),
    horarioAulas: yup.array().default([]),
});
exports.schemaHorario = exports.yupHorario.shape({});
